<template>
    <div class="ser-type">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/site/type-list' }">场地类型管理</el-breadcrumb-item>
                <el-breadcrumb-item>场地类型添加</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增场地类型</h2>
            </div>
        </div>
        <div class="page-content p20">
            <div class="add-box bg_fff p20">
                <el-form ref="form"  :model="form" label-width="100px" align="left" >
                    <el-form-item label="所属大类" prop="fid" style="width: 550px;">
                        <div class="d_flex">
                            <el-select v-model="cate_id" filterable clearable placeholder="输入场地大类关键字">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.cate_id"
                                        :label="item.name"
                                        :value="item.cate_id"
                                >
                                </el-option>
                            </el-select>
                            <span style="margin-left: 10px;font-size: 12px;color: #f00;">不选择为添加场地大类</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="小类名称" prop="username" style="width: 350px;">
                        <el-input v-model="form.name" autocomplete="off"  placeholder="请输入类型名称"></el-input>
                    </el-form-item>
                    <el-form-item  label="图标" style="width: 100%;" prop="fileList">
                        <div class="d_flex">
                            <div class="upload-img-box d_flex" v-if="rulesForm.fileList.length>0">
                                <div class="img" v-for="(item,index) in rulesForm.fileList">
                                    <img :src="item|handleImg" alt="">
                                    <i class="el-icon-error" @click="deleteImg(1,index)"></i>
                                </div>
                            </div>
                            <el-upload class="avatar-uploader"
                                       ref="otherLicense"
                                       :auto-upload="false"
                                       action
                                       :multiple="true"
                                       :on-preview="handlePicPreview"
                                       :on-remove="handleRemove"
                                       :file-list="rulesForm.fileList"
                                       :on-change="otherSectionFile"
                                       list-type="picture-card"
                                       v-if="rulesForm.fileList.length<1"
                            >
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即添加</el-button>
                        <el-button  @click="toList">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {addSiteCate, spacecateList} from '../../api/site'
    import {mapState} from "vuex";
    export default {
        name: "site-type",
        data(){
            return{
                typeList:'',
                cate_id:'',
                form:{
                    name:'',
                    status:1,
                    fid:0,
                    cover:''
                },
                rulesForm:{
                    fileList:[],
                }
            }
        },
        mounted() {
            this.siteTypeList();
        },
        computed:{
            ...mapState(['baseUrl','cityArr'])
        },
        methods:{
            siteTypeList(){
                spacecateList().then(res=>{
                    if(res.code==1){
                        this.typeList=res.data;
                    }
                })
            },
            onSubmit(){
                if(!this.form.name){
                    this.$message.error('请输入类型名称');
                    return;
                }
                if(this.cate_id){
                    this.form.fid=this.cate_id;
                    if(this.rulesForm.fileList.length==0){
                        this.$message.error('请选择类型图标');
                        return;
                    }
                }
                this.form.cover=this.rulesForm.fileList[0]||'';
                addSiteCate(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('添加成功');
                        this.$router.push({path: '/site/list'});
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            toList(){
                this.$router.push({path: '/site/list'});
            },
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.rulesForm.fileList.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'site');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.rulesForm.fileList.push(res.data.data.path);
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .upload-img-box{
        width: 100%;
        .img{
            width: 146px;
            height: 146px;
            border-radius: 4px;
            margin-right: 10px;
            position: relative;
            i{
                position: absolute;
                top: -5px;
                font-size: 24px;
                color: #f00;
            }
            .el-icon-error{
                right: -5px;
            }
            img{
                width: 146px;
                height: 146px;
                border-radius: 4px;
            }
        }
    }
</style>
